import { Component } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { SideNavService } from 'src/app/core-flc/sidenav/sidenav.service';
import { RouterLinkEnum } from 'src/app/enums/router-link-enum';
import { LogMessageDto } from 'src/app/server-api/models';
import { LogMessageControllerService } from 'src/app/server-api/services';
import { DetailComponent } from 'src/app/utils-flc/detail/detail.component';
import { ILogMessageFormGroup } from './ILogMessageFormGroup';

@Component({
  selector: 'app-log-message',
  templateUrl: './log-message.component.html',
  styleUrls: ['./log-message.component.css']
})
export class LogMessageComponent extends DetailComponent {
  logMessage: LogMessageDto;

  constructor(
    public override translate: TranslateService,
    private logService: LogMessageControllerService,
    public override sidenavService: SideNavService,
    public override router: Router,
    private formBuilder: UntypedFormBuilder
  ) {
    super(translate, sidenavService, router);
  }

  override initItem(): void {
    super.initItem();
    //init an empty dto and set the invisible fields
    this.logMessage = {} as any as LogMessageDto;

    this.initForm();
    this.columnsVisible.set('id', false);
  }

  override getItem(request) {
    super.getItem(request);

    this.logService.getLogMessage(request).subscribe((data: LogMessageDto) => {
      this.logMessage = data;
      this.name = data.created;

      this.initForm();
      this.detailForm.controls['id'].disable();

    });
  }

  override setForm() {
    //set visibility fields, set FormGroup and validators
    super.setForm();

    this.columnsVisible = new Map([
      ['id', false],
      ['author', true],
      ['created', false],
      ['lastModificationDate', true],
      ['subject', true],
      ['body', true],
      ['messageType', true],
      ['messageModel', true],
      ['modelId', true],
      ['startChainage', true]
    ]);

    this.detailForm = this.formBuilder.group({
      id: [''],
      author: [{ value: null, disabled: true }],
      created: [{ value:'', disabled: true }],
      lastModificationDate: [{ value:'', disabled: true }],
      subject: [{ value:'', disabled: true }],
      body: [{ value:'', disabled: true }],
      messageType: [{ value:'', disabled: true }],
      messageModel: [{ value:'', disabled: true }],
      modelId: [{ value:'', disabled: true }],
      startChainage: [{ value:'', disabled: true }]
      }) as ILogMessageFormGroup;

    //patch value dto to formGroup
    this.detailForm.patchValue(this.logMessage);
  }

  override initForm() {
    super.initForm();
    this.initDialogDelete('log-message.dialog_title');

    //set topmenu icon actions
    this.translate.get(['icon_refresh', 'icon_menu', 'icon_next', 'icon_previous',]).subscribe((translations: string) => {
      this.topMenuIcons = [
        {
          icon: 'refresh',
          title: translations['icon_refresh'],
          routerLink: null,
          clickMethod: 'refresh',
          hide: false
        },
        {
          icon: 'arrow_back',
          title: translations['icon_previous'],
          routerLink: null,
          clickMethod: 'navigatePrevious',
          hide: this.hidePrevious
        },
        {
          icon: 'arrow_forward',
          title: translations['icon_next'],
          routerLink: null,
          clickMethod: 'navigateNext',
          hide: this.hideNext
        }
      ];
      //only admin can go to the overall list log messages
      if (this.stateService.getProfile().toString().toUpperCase().includes('ADMIN'))
      this.topMenuIcons.push(
        {
          icon: 'menu',
          title: translations['icon_menu'],
          routerLink: RouterLinkEnum.LOG_MESSAGES_LIST.toString(),
          clickMethod: 'dummy',
        });
    });
    this.setForm();
  }


  override saveOk() {
    super.saveOk();
    this.sidenavService.setLoading(false);
    //no save done
  }


  override delete() {
    super.delete();
    this.sidenavService.setLoading(false);
    //no delete done
  }

  gotoDetail()
  {
    switch (this.logMessage.messageModel.toUpperCase())
    {
      case 'SYSPARAM':
        this.router.navigateByUrl(RouterLinkEnum.SYSTEMPARAMS.toString() + this.logMessage.modelId);
        break;
      case 'RASTER':
        this.router.navigateByUrl(RouterLinkEnum.RASTERS.toString() + this.logMessage.modelId);
        break;
      case 'TUNNELSECTION':
      case 'TUNNEL':
        this.router.navigateByUrl(RouterLinkEnum.TUNNEL_SECTIONS.toString() + this.logMessage.modelId);
        break;
      case 'LOADCHAINAGE':
        this.router.navigateByUrl(RouterLinkEnum.LOAD_CHAINAGES.toString() + this.logMessage.modelId);
        break;
        case 'SDTPOSITION':
          this.router.navigateByUrl(RouterLinkEnum.SDT_POSITIONS.toString() + this.logMessage.modelId);
          break;
      case 'CATEGORY':
        this.router.navigateByUrl(RouterLinkEnum.RASTER_CATEGORIES.toString() + this.logMessage.modelId);
        break;
        case 'USER':
          this.router.navigateByUrl(RouterLinkEnum.USERS.toString() + this.logMessage.modelId);
          break;
    }
  }
}


